<template>
	<div class="business-article">
		<div class="column">
			<div class="content">
				<div class="content-inner u-pt4em-pc">
					<p class="content-catch u-ls0-pc u-MT2em-sp">
						メカ・エレキ・ソフトを自社で一貫して開発。<br />ロボットのプロジェクトは90%が新規開発案件。
					</p>
					<div class="content-text">
						<p>
							これまでは自動車や電気電子産業など大量生産の工場を中心に、産業用ロボットが活用されてきました。しかし、最近では、少量多品種のものづくり工場や、食品・医薬品・化粧品の「三品産業」、サービス産業など、多岐にわたる産業でロボットの活用が拡がってきています。
						</p>
						<p>
							ロボットの活用範囲を拡大するためには、メカ、エレキ、ソフトの総合的な知見、ロボット工学、システム工学に加えて、最新のAIやクラウド技術など多方面の技術が必要です。よって、ロボットメーカーやロボットを導入するユーザーだけで、全ての技術に対応することは難しくなってきています。
						</p>
						<p>
							豆蔵は、これまでにメカ・エレキ・ソフト含めたシステム全体でのロボット開発やソフトウェア開発を経験してきました。それらの技術・経験を活かして、ロボットメーカー向けの新規ロボット開発支援や、ロボット導入を検討しているユーザー向けのロボットシステムインテグレート（ロボットSI)およびコンサルティングを実施しています。また、新しい技術を取り入れた自社製のオリジナルロボットも試作開発しており、展示会などで高評価を得ています。その結果、ロボットメーカーやロボットを導入するユーザーから多くのご依頼をいだたいており、その90%が新規開発案件となっているのです。
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 領域の強み -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					ロボット領域の強み
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt6em-pc">
					<div class="content-lead">
						<div class="content-num content-num--1">
							<img src="../../assets/common/num01.svg" alt="1" width="51" height="52" />
						</div>
						<p class="content-catch">メカ・エレキ・ソフトを一貫して開発できる</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							ロボットを開発するためには、ハードウェアとソフトウェアの協調設計が重要です。豆蔵のロボット開発の強みの一つは、メカ・エレキ・ソフトを豆蔵一社でワンストップに開発できること。複数の会社で分担して開発するケースでは、会社間の調整で時間を要したり、場合によっては責任のなすりつけ合いが起きたり、といった場面が多く発生します。ワンストップで開発することで、システムのゴールに向けた最適な設計を短期間で進めることができるのです。また、独立系企業でロボット本体の開発ができるSIerは非常に少ないです。ロボットの内部のことを熟知していますので、より技術的難易度の高いSI案件にも対応できますし、市販ロボットで実現できない場合にはカスタムロボットを開発するといった提案ができるのも、他社にはない豆蔵の強みです。
						</p>
					</div>
					<div class="content-lead">
						<div class="content-num">
							<img src="../../assets/common/num02.svg" alt="2" width="62" height="52" />
						</div>
						<p class="content-catch">ソフトウェアエンジニアリングに基づいた開発</p>
					</div>
					<div class="content-text u-mt2em-pc">
						<p>
							従来の産業用ロボットではティーチングプレイバックで決められた動作を繰り返すだけでしたが、近年ではセンサーやカメラの情報を使って自律制御したり、クラウド等の外部システムと連携したり、AI技術を活用したりとロボットへの要求が非常に高度化しています。このため、ロボットシステムは、大規模化、複雑化、高機能化しており、ますますソフトウェアの技術が重要になってきているのです。
						</p>
						<p>
							これらのニーズに対応するために、豆蔵は数多くの開発、コンサルティングを実践してきた経験を活かしています。システムズエンジニアリングやソフトウェアエンジニアリング技術を活用するだけではなく、豆蔵の得意なモデリング技術、シミュレーション技術を活かしています。また、豆蔵はコンサルティングや教育も得意としています。お客様自身でロボット開発ができるように技術者教育を実施し、お客様の開発プロセスを改善することができるのも豆蔵の強みとなっています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 代表的なプロジェクト事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					代表的なプロジェクト事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pb5em-pc">
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--1">
								<img src="../../assets/robot/icon_industory.svg" alt="" width="84" height="68" />
							</div>
							<p class="content-iconText">産業用ロボット<br class="over_display" />開発支援</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">未経験でロボット開発にチャレンジ</p>
							<p>
								豆蔵は、2013年からロボットの開発ビジネスを始めています。きっかけは海外のロボットメーカーからの依頼です。6軸産業用ロボットのコントローラ、ティーチングペンダントのハードウェアおよびソフトウェアを開発してほしいという内容でした。
							</p>
							<p>
								それまでは産業用ロボットの開発経験はなかったので、非常にチャレンジングな案件ではありました。しかし、「困難な山の頂を目指す」という豆蔵グループのポリシーにあるように、難しい案件を得意とする会社でありますので、システム工学にロボット工学を加えることで実現できると判断し、開発を受託することにしました。
							</p>
							<p>
								ロボット工学は東京農工大の遠山茂樹教授にコンサルティングいただいて一から学習しました。開発は非常に苦労しましたが、どうにか２年で基本機能を開発し、溶接、切断、研磨、パレタイジング等の応用機能も開発することができました。コントローラ、ペンダントの開発が成功したことを受け、お客様からロボットアームの設計もご依頼いただきました。これまでロボットアームはおろか、メカ設計はやっていなかったので、非常に難しい案件でありましたが、チャレンジしました。とは言え、未経験であったので、まずは後述する東京農工大との共同研究を通してロボットアームの設計手法を確立し、その手法を利用して試作開発を実施するステップを踏みました。この案件を通して、産業用ロボットを構成するメカ、エレキ、ソフトを全て自社開発する技術を、獲得することができたのです。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--2">
								<img src="../../assets/robot/icon_school.svg" alt="" width="108" height="75" />
							</div>
							<p class="content-iconText">東京農工大との<br class="over_display" />共同研究</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">ロボットアームのメカ設計技術を獲得</p>
							<p>
								東京農工大の遠山教授と「産業用ロボットアームの開発期間を短縮する設計手法」を1年半ほどかけて共同研究しました。一般的にロボットアームの開発では、実機の試作・検証を繰り返します。経験のあるロボットメーカーであれば既存資産を流用することで設計期間を短縮できますが、新規参入のロボットメーカーで同様の開発を行うと開発期間が長期化してしまいます。
							</p>
							<p>
								そこで、共同研究では遠山教授のロボット工学の知識に、豆蔵の得意とするモデルベース開発技術、シミュレーション技術、開発プロセス構築技術を応用することで、少ない試作回数で量産機レベルの性能を達成する設計手法を構築しました。豆蔵のロボットアーム設計ではここで確立した設計手法を活用しています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/robot/icon_inhouse.svg" alt="" width="84" height="67" />
							</div>
							<p class="content-iconText">
								自社開発ロボット
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								樹脂製の7軸協働ロボット「Beanus 2」
							</p>
							<p>
								Beanus2は、豆蔵が三井化学、日本電産シンポと共同開発を行った、オリジナルの協働ロボットです。豆蔵がロボットアーム、コントローラの設計を行い、三井化学が樹脂成形技術、日本電産シンポが高バックドライバビリティ減速機を提供しました。ロボットアームを樹脂化することで、金属製のロボットアームと比べて１／２まで軽量化することができました。また、高バックドライバビリティ減速機の高効率・低摩擦を活用することで、モータ電流で高精度に外力を推定することができ、トルクセンサーなしで衝突検知やダイレクトティーチングを実現しました。軽さと柔らかさを実現するロボットの新しい設計手法をロボット業界に提案し、展示会で大きな反響を得ることができたのです。現在では、この技術を応用してロボットメーカーへの開発支援も行っています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/robot/icon_arms.svg" alt="" width="111" height="69" />
							</div>
							<p class="content-iconText">
								双腕ロボット開発
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								プロダクトだけでなくプロセスも提供
							</p>
							<p>
								あるロボットメーカーからの依頼を受けて双腕ロボットの試作機開発を行いました。本開発ではロボットメーカーからの提案依頼を受け、新しい価値を提供する双腕ロボットの商品企画、コンサルティングを行いました。その後は、システム設計からロボットアーム、コントローラ、ペンダントなど、全ての構成要素を豆蔵で一から試作開発しました。さらに、本開発で適用したモデルベース開発手法などの技術も含めて、ロボットメーカーにスキルトランスファーしました。これにより、ロボットメーカーはプロダクトだけでなくプロセスも獲得することができ、その後のビジネスの成功に繋げられました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/robot/icon_food.svg" alt="" width="119" height="85" />
							</div>
							<p class="content-iconText">飲食店向けロボット<br class="over_display" />導入支援</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								お客様とともにシステム開発
							</p>
							<p>
								飲食店における人手不足を解消するために、厨房での食器洗浄工程をロボットで自動化するロボットSI案件を進めています。水槽内の食器を選別して洗浄機に投入し、洗浄後の食器を移設する一連の工程をロボットで自動化しています。システム開発では工程を細分化し、食器把持用のロボットハンド、食器の整列機構、食器識別の画像処理などの要素技術を確立し、ステップバイステップでシステム化に繋げていきました。
							</p>
							<p>
								システム開発では当初からお客様の要求が固まっていることは稀であり、要求ヒアリングしてもぼんやりとしたものしか出てきません。その中でいきなり最終システムを仕上げてしまうと「思っていたのと違う」とか「要求する性能が出ていない」といったトラブルになることもあります。そのため、技術課題を抽出して一つひとつ潰していく、お客様を巻き込んで一緒に開発を進めていく、といったアプローチが非常に有効です。本案件は厨房というロボットの導入が進んでいない環境に向けたシステムであり、開発においては多くの課題がありました。例えば、水場やスチーム環境下での画像処理では非常に難易度が高かったですが、実現できること、できないことを明確にして、双方納得の上でシステム化に取り組みました。
							</p>
						</div>
					</div>
					<div class="content-iconFlex">
						<div class="content-iconContainer">
							<div class="content-icon content-icon--3">
								<img src="../../assets/robot/icon_lazer.svg" alt="" width="113" height="89" />
							</div>
							<p class="content-iconText">
								レーザー溶接ロボット
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="content-textLead">
								レーザー溶接ロボットシステムの製品販売
							</p>
							<p>
								板金加工業向けにロボットとレーザー溶接技術を融合したレーザー溶接ロボットシステムを開発し製品販売を行っています。ロボットを従来の板金加工の製造工程に加えることで、レーザー加工のアイドルタイムをなくし、稼働効率の向上および高品質な溶接を実現しています。さらにお客様の作業効率をアップするための各種機能を随時開発しています。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- 領域の組織構成 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					ロボット領域の組織構成
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt5em-pc u-pb3em-pc">
					<div class="content-text u-mt0">
						<p class="u-mt0-sp">
							ロボット開発の組織は、ロボット本体開発およびSIを担当しているチームとレーザー溶接ロボットの開発・販売を担当しているチームがあります。また、ロボットシステムを実現するためには広範囲な技術が必要となり、クラウド技術、AI技術などについては他の事業部の技術者とも連携しながら開発を進めています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 今後の展望 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					今後の展望
				</h3>
			</div>
			<div class="image">
				<img src="../../assets/robot/photo01.jpg" alt="" width="1840" height="600" />
			</div>
			<div class="content">
				<div class="content-inner underImage u-pb3em-pc">
					<p class="content-catch">
						ロボット業界への貢献
					</p>
					<div class="content-text u-mt2em-pc">
						<p>
							豆蔵は日本の製造業やサービス業の生産性向上や品質向上、そして少子高齢化に伴う労働者不足の課題を解決するために、ロボット開発やロボット導入支援で貢献していきたいと考えています。特に、今後ロボットの適用範囲を広げていくためには、これまで以上に自律性や複雑な動作が求められ、また人間と共存するための安全性が求められていきます。豆蔵は、ロボット工学、システム工学の基盤技術に、AIやクラウドなどソフトウェア技術を応用した高度なロボットシステムの開発を提案し、業界全体を技術でリードする立場になっていきたいです。イベントやメディアでも様々な発信を継続することで、ロボット開発の一つの方向性を業界全体に提示していくことも、私たちのミッションのひとつと考えています。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 求める人物像 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner">
					求める人物像
				</h3>
			</div>
			<div class="content">
				<div class="content-inner bgGray u-pt4em-pc">
					<p class="content-catch u-LS10-pc u-wsn-pc">
						ものづくりが大好きで、技術への探究心を持ち、自己学習できる人
					</p>
					<div class="content-text u-mt3em-pc">
						<p>
							ものづくりが大好き、世の中に無いものを作りたい、新しい技術・難しい技術にチャンレンジしたいというエンジニアが、このチームに集まっています。メーカーで長年ロボットを開発していたエンジニア、ベンチャーで先進的なロボットを開発していたエンジニア、高度なソフトウェア技術をロボットに応用したいエンジニアなど、多種多様なエンジニアが新しいロボット開発にチャレンジしています。
						</p>
						<p>
							組込み、ロボット、業務システムの領域を問わず、組織の垣根を越えて勉強会も開催しています。社外にもメディアやイベントを通じて技術的な知見を発信するカルチャーです。そのような環境で自身の探究心を満たしたい方は、水を得た魚のように楽しみながら仕事ができます。
						</p>
						<p>
							ロボット領域では、次々と技術革新が起きています。現場での開発で試行錯誤しながら、業界全体の技術トレンドをウォッチして自己学習できる方が成長しています。豆蔵には、「従来の企業の枠を超えて、新たなプロダクトやソリューションを開発することで、自分を成長させたい」という方が多く入社しています。そのようなカルチャーに身を置きたい方が活躍できる環境です。
						</p>
					</div>
				</div>
			</div>
		</article>
		<!-- 活躍事例 -->
		<article class="column">
			<div class="title-wrap">
				<h3 class="title-wrap-inner u-ls10-pc">
					活躍事例
				</h3>
			</div>
			<div class="content">
				<div class="content-inner u-pt65em-pc">
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Aさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								産業用ロボットメーカー出身のメカトロエンジニア。各社で類似の開発をしている現状に疑問を感じ、コンサルタントとしてロボット業界全体の発展のために提言していきたいと豆蔵に入社。以来、ロボット導入が進んでいない産業に向けたロボット開発や、新規参入メーカー向けのコンポーネントの開発に従事し、ロボット業界の活性化に向けた活動をしています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Bさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								産業用ロボットメーカー出身のメカエンジニア。自身の思い描くロボットを作りたい、新規開発案件を通してメカ開発技術を向上させたいと豆蔵に入社。以来、新しいコンセプトのロボットアームの設計やモータユニットの設計に従事しています。全ての案件が構想段階から参画する新規開発の案件です。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Cさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								ロボットベンチャー出身のソフトエンジニア。技術者集団である豆蔵で、多様な技術者に刺激を受けながらロボット開発をしたいと入社。以来、ビジョンシステムの開発を中心にモーション制御などのソフトウェア開発に従事しています。社内勉強会でUMLのモデリングを習得し、業務でも活用しています。
							</p>
						</div>
					</div>
					<div class="content-iconFlex --person">
						<div class="content-iconContainer --person">
							<div class="content-icon">
								<img src="../../assets/business_platform/icon_person.svg" alt="" width="113" height="120" />
							</div>
							<p class="content-iconText">
								Dさん
							</p>
						</div>
						<div class="content-text u-mt0-pc">
							<p class="u-mt0-pc">
								電気機器メーカー出身のソフトエンジニア。組込ソフトウェアのコンサルティング（モデリング、アーキテクチャ構築等）や技術難易度の高い開発がしたいと豆蔵に入社。以降、IoTデバイスの開発やロボットコントローラの組み込みソフトウェア開発に従事しています。UMLを駆使し、要求から詳細設計までモデル駆動開発を実践しています。
							</p>
						</div>
					</div>
				</div>
			</div>
		</article>
		<!-- キーマンインタビュー１ -->
		<article class="column keyman">
			<div class="keyman_flex">
				<h3 class="keyman_title">
					<span class="top"
						>キーマンインタビュー<img src="../../assets/common/num01_white.svg" alt="1" width="22" height="23"
					/></span>
					<span class="mid">新規開発案件が90%</span>
					<span class="bottom">ロボット領域 リーダー：Seiji </span>
				</h3>
				<div class="keyman_image">
					<img src="../../assets/robot/photo02.jpg" alt="" width="1260" height="761" />
				</div>
			</div>
			<div class="content u-bg0-pc">
				<div class="content-inner underImage">
					<div class="content-text --interview u-mt0">
						<p class="u-mt0">
							前職では電機メーカーで衛星通信のソフト開発に従事していました。ソフトウェアの技術コンサルタントになるために豆蔵に入社。以降、モデル駆動開発、開発プロセスのコンサルティングを経て、2013年から産業用ロボット開発に参画し、数々のロボット開発にPLとして従事してきました。
						</p>
						<p>
							豆蔵はロボットメーカーではなく、ロボットを開発する会社です。ロボットメーカー以外でメカ、エレキ、ソフトをすべてカバーして、ロボットを一から開発できる会社は独立系企業では非常に珍しいです。受注する案件の90%は新規開発になっています。メーカーでは既存製品の機能追加などの派生開発が多いですが、豆蔵は開発会社であり、技術が売りの会社ですので、先端技術を導入した新規開発が多くなっています。この点に魅力を感じてジョインしてくれるエンジニアが多いです。まっさらなキャンパスの上に自分が設計した部品で製品を組み上げていくのはエンジニアの醍醐味であり、設計通りに動作した時の感動は何物にも代え難いです。そのような機会を求める方には、豆蔵のロボットチームはこれ以上のない環境となるでしょう。
						</p>
					</div>
				</div>
			</div>
		</article>

		<article class="column linkBox">
			<router-link to="/people_seiji">
				<h3 class="linkBox_title">
					ロボット領域<span class="over_display --inline">：</span><br class="under_display" />インタビュー記事はこちら
				</h3>
				<div class="linkBox_inner">
					<p class="linkBox_text u-font-ots">
						ソフト・メカ・エレキ。<br />
						全ての技術を融合させ、<br />豆蔵オリジナルロボットが誕生した。
					</p>
					<picture class="linkBox_bg">
						<source srcset="../../assets/robot/photo03_pc.jpg" media="(min-width: 1161px)" />
						<img src="../../assets/robot/photo03_sp.jpg" alt="" />
					</picture>
				</div>
			</router-link>
			<p class="link-text">
				<a class="u-external" href="https://note.com/mamezou_info/n/n51d502d4056b" target="_blank"
					>ロボット業界の展望と豆蔵が担う未来/豆蔵のロボット開発の魅力とエンジニアのキャリアについて
				</a>
			</p>
		</article>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'robot-article',
};
</script>

<style lang="scss" scoped>
// * {
// 	color: red !important;
// }
@keyframes gradientAnime {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
.business-article {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-bottom: 100px;
}
.column {
	position: relative;
	margin: 0 auto;
	margin-bottom: 140px;
	@media print, screen and (max-width: 1160px) {
		width: 90%;
		margin-bottom: 100px;
	}
	&:after {
		content: '';
		width: 150%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// top: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:before {
		content: '';
		width: 100%;
		height: 300px;
		display: block;
		background: linear-gradient(to right, #ffcf82 0%, #543194 100%);
		background-size: 200% 200%;
		animation: gradientAnime 10s ease infinite;
		position: absolute;
		// bottom: 0;
		transform: skewY(-20deg);
		transform-origin: left top;
		z-index: -1;
	}
	&:nth-child(1) {
		&:after {
			content: none;
			// width: 150%;
			// top: 0;/
			// transform-origin: left top;
		}
		&:before {
			content: none;
			// width: 100%;
			// bottom: 0;
			// transform-origin: left top;
			// left: -50%;
		}
	}
	// ビジネスプラットフォーム領域の強み
	&:nth-child(2) {
		&:after {
			width: 150%;
			// top: 30%;
			// transform-origin: left top;
			// width: 100vw;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			// width: 100%;
			// bottom: -20%;
			// transform-origin: left top;
			// left: -50%;
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 代表的なプロジェクト事例
	&:nth-child(3) {
		&:after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
	// ビジネスプラットフォーム領域の組織構成
	&:nth-child(4) {
		&:after {
			width: 150%;
			top: -10%;
			left: -10%;
			transform-origin: left top;
			@media print, screen and (min-width: 920px) {
				top: 5%;
				left: 0;
			}
		}
		&:before {
			content: none;
		}
	}
	// 今後の展望
	&:nth-child(5) {
		&:after {
			content: none;
		}
		&:before {
			width: 150%;
			bottom: -5%;
			transform-origin: left top;
			left: -10%;
			@media print, screen and (min-width: 920px) {
				transform-origin: right top;
				left: auto;
				right: 1px;
				bottom: 15%;
				width: 100vw;
			}
		}
	}
	// 求める人物像
	&:nth-child(n + 6) {
		&::after {
			content: none;
		}
		&:before {
			content: none;
		}
	}
}

.column.keyman {
	@media print, screen and (min-width: 1161px) {
		margin-bottom: 0;
	}
	& + .column.keyman {
		@media print, screen and (min-width: 1161px) {
			margin-top: 60px;
		}
	}
	.content-inner {
		@media print, screen and (min-width: 1161px) {
			padding-bottom: 0;
		}
	}
	.keyman_flex {
		display: flex;
		flex-direction: column;
		align-items: center;
		@media print, screen and (min-width: 1161px) {
			flex-direction: row;
			align-items: flex-end;
		}
	}
	.keyman_title {
		display: flex;
		flex-direction: column;
		gap: 1em;
		position: relative;
		z-index: 1;
		width: 80vw;
		margin: 0;
		padding: 2em 0 2em 2em;
		box-sizing: border-box;
		font-family: 'ots-mincho', serif;
		background-color: #543193;
		color: #fff;
		@media print, screen and (min-width: 1161px) {
			justify-content: center;
			width: 380px;
			flex: 0 0 380px;
			padding: 2em 0 2em 3em;
			margin-bottom: 40px;
			margin-right: -90px;
		}
		span {
			display: block;
			img {
				display: block;
				width: 16px;
				@media print, screen and (min-width: 1161px) {
					width: 22px;
				}
			}
		}
		.top {
			display: flex;
			align-items: center;
			font-size: 12px;
			gap: 1em;
			font-weight: normal;
			@media print, screen and (min-width: 1161px) {
				font-size: 16px;
				letter-spacing: -0.05em;
			}
		}
		.mid {
			font-size: 19px;
			line-height: calc(70 / 38);
			font-weight: normal;
			letter-spacing: 0;
			@media print, screen and (min-width: 1161px) {
				letter-spacing: -0.05em;
				font-size: 26px;
				line-height: calc(50 / 26);
			}
		}
		.bottom {
			font-weight: bold;
			font-size: 12px;
			font-family: 'Noto Sans JP', sans-serif;
			letter-spacing: 0.1em;
			@media print, screen and (min-width: 1161px) {
				font-size: 14px;
			}
		}
	}
	.keyman_image {
		position: relative;
		z-index: 0;
		margin: -20px calc(50% - 50vw) 0;
		width: 100vw;
		@media print, screen and (min-width: 1161px) {
			flex: 0 0 630px;
			width: 630px;
			margin: 0;
		}
		img {
			vertical-align: bottom;
		}
	}
}
.title-wrap {
	top: -1.5em;
	display: inline-block;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: absolute;
	@media print, screen and (max-width: 1160px) {
		top: -30px;
		font-size: 12px;
	}
	h3 {
		font-family: 'ots-mincho';
		padding: 0 2em;
		text-align: left;
		position: relative;
		letter-spacing: 0.05em;
		font-weight: normal;
		@media print, screen and (min-width: 1161px) {
			padding: 0 3.5em;
			font-size: 16px;
			letter-spacing: 0;
		}
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.image {
	margin: 0 calc(50% - 50vw);
	width: 100vw;
	height: 32.67vw;
	@media print, screen and (min-width: 1160px) {
		margin: 0;
		width: 100%;
		height: 300px;
	}
	img {
		vertical-align: middle;
	}
}
.content {
	background-color: #fff;
}
.content-inner {
	padding: 120px 100px 3.5em 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 80px 5% 50px 5%;
	}
	&.grayBox {
		padding-top: 2.5em;
		padding-bottom: 1.5em;
		background-color: #e7e7e7;
		@media print, screen and (min-width: 1161px) {
			padding: 3em 50px;
		}
	}
	&.underImage {
		padding: 50px 100px 100px 100px;
		@media print, screen and (max-width: 1160px) {
			padding: 40px 5% 50px 5%;
		}
	}
	&.bgGray {
		background-color: #e7e7e7;
	}
}

.grayBoxContainer {
	display: flex;
	flex-direction: column;
	gap: 40px;
	@media print, screen and (min-width: 1161px) {
		flex-wrap: wrap;
		flex-direction: row;
		gap: 5px;
	}
}

.grayBox {
	position: relative;
	@media print, screen and (min-width: 1161px) {
		flex: 0 1 calc(50% - 5px);
		box-sizing: border-box;
	}
	&_title {
		display: inline-block;
		position: absolute;
		top: -1.5em;
		left: 50%;
		transform: translateX(-50%);
		background-color: #543193;
		width: 230px;
		padding: 1em 0;
		margin: 0;
		color: #fff;
		font-size: 12px;
		font-weight: bold;
		text-align: center;
		line-height: 1;
		letter-spacing: 0.05em;
		white-space: nowrap;
		@media print, screen and (min-width: 1161px) {
			box-sizing: border-box;
			width: 260px;
			font-size: 13px;
			padding: 1em 0;
		}
	}
	&_desc {
		font-size: 12px;
		line-height: 2;
		text-align: justify;
		text-justify: inter-ideograph;
		text-justify: inter-character;
		@media print, screen and (min-width: 1161px) {
		}
	}
}

.content-lead {
	&:not(:first-of-type) {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	@media print, screen and (min-width: 1161px) {
		display: flex;
		align-items: center;
		gap: 40px;
	}
}

.content-num {
	width: 31px;
	@media print, screen and (min-width: 1161px) {
		width: 37px;
	}
	&--1 {
		width: 25px;
		@media print, screen and (min-width: 1161px) {
			width: 30px;
		}
	}
	img {
		width: 100%;
	}
}

.content-iconFlex {
	@media print, screen and (min-width: 1161px) {
		display: flex;
		justify-content: flex-end;
		gap: 50px;
		.content-text {
			flex: 0 0 530px;
		}
	}
	& + & {
		margin-top: 4em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 3em;
		}
	}
	&.--person {
		@media print, screen and (min-width: 1161px) {
			gap: 50px;
		}
	}
}
.content-iconFlex.--person + .content-iconFlex.--person {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2.5em;
	}
}

.content-iconContainer {
	display: flex;
	align-items: center;
	gap: 30px;
	@media print, screen and (min-width: 1161px) {
		flex: 1 1 auto;
		gap: 10px;
		flex-direction: column;
	}
	&.--person {
		gap: 0;
		flex-direction: column;
		.content-icon {
			@media print, screen and (min-width: 1161px) {
				width: 55px;
				margin-top: 5px;
			}
		}
	}
}
.content-icon {
	&--1 {
		width: 52px;
		@media print, screen and (min-width: 1161px) {
			width: 70px;
		}
	}
	&--2 {
		width: 45px;
		@media print, screen and (min-width: 1161px) {
			width: 65px;
		}
	}
	&--3 {
		width: 49px;
		@media print, screen and (min-width: 1161px) {
			width: 62px;
		}
	}
}

.content-iconText {
	font-size: 12px;
	font-weight: bold;
	margin: 0;
	@media print, screen and (min-width: 1161px) {
		font-size: 14px;
		text-align: center;
		white-space: nowrap;
	}
}

.content-catch {
	font-size: 26px;
	font-family: 'ots-mincho', serif;
	letter-spacing: 0;
	margin: 0;
	line-height: calc(61 / 26);
	@media print, screen and (max-width: 1160px) {
		margin-top: 0.5em;
		font-size: 18px;
		line-height: calc(68 / 36);
	}
}
.content-text {
	font-size: 12px;
	text-align: justify;
	margin-top: 4em;
	// @media print, screen and (min-width: 1161px) {
	// 	margin-top: 4em;
	// }
	&.--interview p {
		@media print, screen and (min-width: 1161px) {
			font-size: 14px;
			line-height: calc(30 / 14);
		}
	}
	p {
		font-family: 'Noto Sans JP', sans-serif;
		font-weight: 500;
	}
	p:not(:first-of-type) {
		margin-top: 2.5em;
		@media print, screen and (min-width: 1161px) {
			margin-top: 2em;
		}
	}
	p.content-textLead {
		font-family: 'ots-mincho', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 1.5em;
		@media print, screen and (min-width: 1160px) {
			margin-top: -0.5em;
			font-size: 23px;
			line-height: calc(41 / 23);
		}
	}
	p.lg {
		font-family: 'Noto Serif JP', serif;
		font-size: 18px;
		line-height: calc(68 / 36);
		letter-spacing: 0;
		margin-top: 0;
		@media print, screen and (min-width: 1160px) {
			font-size: 26px;
			line-height: calc(61 / 26);
		}
	}
}
.case {
	background-color: #dddddd;
}
.case-inner {
	padding: 0 100px 50px 100px;
	@media print, screen and (max-width: 1160px) {
		padding: 0 5% 50px 5%;
	}
}
.case-title {
	font-size: 14px;
	background-color: #543193;
	color: #fff;
	display: inline-block;
	margin: 0;
	padding: 0 30px;
}
.case-text {
	font-size: 12px;
	margin-top: 40px;
	text-align: justify;
}
.case-catch {
	font-size: 17px;
}

.linkBox {
	@media print, screen and (min-width: 1161px) {
		margin-top: 140px;
		max-width: 830px;
	}
	&_title {
		display: inline-block;
		position: relative;
		margin: 0;
		padding: 1em 2em 1em 2.5em;
		background-color: #e7e7e7;
		color: #543193;
		font-weight: bold;
		font-size: 11.5px;
		line-height: calc(40 / 23);
		letter-spacing: 0.05em;
		@media print, screen and (min-width: 1161px) {
			font-size: 13px;
		}
		&::before {
			content: '';
			display: inline-block;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 1em;
			height: 2px;
			background-color: currentColor;
		}
	}
	&_inner {
		position: relative;
	}
	&_text {
		position: absolute;
		top: 50%;
		left: 1.5em;
		transform: translateY(-50%);
		margin: 0;
		font-family: 'Noto Serif JP', serif;
		color: #fff;
		letter-spacing: 0;
		font-size: 15px;
		line-height: calc(64 / 30);
		@media print, screen and (min-width: 1161px) {
			left: 3.5em;
			font-size: 24px;
			line-height: calc(53 / 24);
			letter-spacing: -0.1em;
		}
	}
	&_bg {
		display: block;
		source,
		img {
			vertical-align: bottom;
		}
	}
}

.link-text {
	margin-top: 3em;
	font-family: 'Noto Sans JP', sans-serif;
	font-size: 13px;
	line-height: calc(43 / 26);
	letter-spacing: 0;
	text-align: justify;
	text-justify: inter-ideograph;
	text-justify: inter-character;
	@media print, screen and (min-width: 1161px) {
		margin-top: 4em;
		text-align: center;
		font-size: 15px;
		a.u-external {
			text-underline-offset: 0.5em;
		}
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}

.u-bg0-pc {
	@media print, screen and (min-width: 1161px) {
		background-color: transparent !important;
	}
}

.u-mt0-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 0 !important;
	}
}
.u-mt2em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 2em !important;
	}
}
.u-mt3em-pc {
	@media print, screen and (min-width: 1161px) {
		margin-top: 3em !important;
	}
}
.u-pb3em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 3em !important;
	}
}
.u-pt4em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 4em !important;
	}
}
.u-pt5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 5em !important;
	}
}
.u-pb5em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5em !important;
	}
}
.u-pb55em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-bottom: 5.5em !important;
	}
}
.u-pt6em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6em !important;
	}
}
.u-pt65em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 6.5em !important;
	}
}
.u-pt7em-pc {
	@media print, screen and (min-width: 1161px) {
		padding-top: 7em !important;
	}
}

.u-wsn-pc {
	@media print, screen and (min-width: 1161px) {
		white-space: nowrap !important;
	}
}

.u-LS10-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.1em !important;
	}
}
.u-LS05-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: -0.05em !important;
	}
}

.u-ls0-pc {
	@media print, screen and (min-width: 1161px) {
		letter-spacing: 0 !important;
	}
}

.u-ls10-pc {
	letter-spacing: 0.1em !important;
}
</style>
